<template>
	<div>
		<modal name="order_timeup" height="auto">
			<OrderTimeUp />
		</modal>
		<div class="head_order">
			<div class="order_logo">
				<router-link to="/">
					<LOGO />
				</router-link>
			</div>
			<div class="mobile_only head_order_title">{{ permenent ? "" : "ביצוע הזמנה" }}</div>
			<div class="backto_bt backto_bt-cart">
				<a href="javascript:void(0);" @click="goToCart()">
					{{ permenent ? "בחזרה להזמנה קבועה" : "בחזרה לעגלה" }}
					<span>></span>
					<CART2 />
				</a>
			</div>
		</div>

		<section class="page_padd page_padd-check">
			<div class="container clearfix">
				<form id="checkout" @submit.prevent="submitCheckOut" @keypress.enter.prevent="enterPressed">
					<input
						type="hidden"
						id="createaccount"
						name="createaccount"
						value="1"
						v-if="!userExists && (!userLogged || userCheckoutInfo.newUser)"
					/>
					<info ref="checkoutInfo" />
					<shipment v-if="!permenent" ref="checkoutShipment" />
					<shipmentPer v-if="permenent" ref="checkoutShipment" />
					<payment :errorText="errorText" />
				</form>
			</div>
		</section>
	</div>
</template>
<script>
	/** Vue Components */
	import axios from "axios";
	import Info from "../components/Checkout/Info";
	import Shipment from "../components/Checkout/Shipment";
	import Payment from "../components/Checkout/Payment";
	import LoginForm from "../components/Forms/LoginForm";
	import VueSimpleSuggest from "vue-simple-suggest/dist/cjs";
	import router from "../router";
	import store from "../store";
	import OrderTimeUp from "../components/Popups/Ordertimeup";
	import shipmentPer from "../components/Checkout/shipmentPermenent";
	/** SVG icons */
	import LOGO from "../assets/img/logo.svg";
	import CART2 from "../assets/img/cart2.svg";
	import CARMELLA from "../assets/img/carmella.svg";
	import { mapState, mapActions, mapGetters } from "vuex";

	export default {
		store,
		metaInfo() {
			return {
				title: "כרמלה - קופה וסיכום הזמנה",
				// titleTemplate: '%s - כרמלה'
			};
		},
		data() {
			return {
				searchUser: "",
				checkoutUrl: this.$wpData.checkout_url,
				homeUrl: this.$wpData.home_url,
				stageComplete: 0,
				users: [],
				verifiedProducts: false,
				showScreen: this.$store.state.userLogged && !this.$store.state.isAdmin ? false : true,
				errorText: false,
			};
		},
		mounted() {
			if (!this.permenent) {
				this.$store.commit("setPerEdit", false);
			}
			let time = 1000 * 60 * 15;
			setTimeout(() => {
				if (this.$store.state.orderEdit) {
					let newUrlLink = this.homeUrl + "/checkout/";
					if (typeof this.timeLeft !== "object") {
						this.$store.commit("setOrderEdit", false);
						this.$store.commit("clearCart");
						this.$router.push("/");
						window.location = this.homeUrl;
					}
					window.location = newUrlLink;
				} else {
					let newUrlLink = this.homeUrl + "/checkout/";
					window.location = newUrlLink;
				}
			}, time);
			if (this.$route.query.removeOrder) {
				this.$modal.show("order_timeup");
				this.$router.push({ query: Object.assign({}) });
			}
			if (this.$store.state.orderEdit) {
				this.$ajax({
					method: "POST",
					url: homeUrl + "?checkOrderStatus",
					params: {
						docNumber: this.$store.state.orderEditMeta.meta.doc_number[0],
						orderId: this.$store.state.orderEditMeta.orderID,
					},
				})
					.then((res) => {
						if (res.data.status == 200 && res.data.order_status == 1) {
						} else {
							this.$store.commit("setOrderEdit", false);
							//this.$router.push('/');
						}
					})
					.catch((e) => console.log(e));
			}
			this.$store.commit("changeCheckoutStage", "info");
			this.$root.$on("stage-complete", (event) => {
				this.stageComplete = event;
			});
			let id = this.cities.find((c) => c.city_name == (this.city ? this.city : this.userLoggedInfo.city));
		},
		computed: {
			...mapState(["isAdmin", "cities", "city", "userLogged", "userLoggedInfo", "orderAs"]),
			...mapGetters(["userCheckoutInfo"]),
			showEnterScreen: {
				get: function () {
					/*if(this.$store.state.userLogged && this.isAdmin)
                                                                                                                   return true;*/
					return this.showScreen;
				},
				set: function (value) {
					this.showScreen = true;
				},
			},
			userLogged() {
				if (this.$store.state.userLogged) {
					return true;
				}
				return false;
			},
			userExists() {
				return this.$store.state.checkoutUserExists;
			},
			permenent() {
				if (
					(this.$store.state.createPermenantOrder == "true" ||
						this.$store.state.createPermenantOrder == true) &&
					this.$store.state.allowPermOrder
				) {
					return true;
				}
				return false;
			},
			permenentEdit() {
				if (typeof this.$store.state.permenantOrderEdit == "object" && this.$store.state.permenantOrderEdit) {
					return true;
				}
				return false;
			},
			timeLeft() {
				if (!this.$store.state.orderEdit) {
					return false;
				}
				if (!this.$store.state.orderEditMeta.jckwds_date[0] && !this.order.meta.jckwds_timeslot[0]) {
					return false;
				}
				let date = this.$store.state.orderEditMeta.meta.jckwds_date[0].split("/");
				let hour = this.$store.state.orderEditMeta.meta.jckwds_timeslot[0].split(" - ")[0];
				let string_time = "20" + date[2] + "-" + date[0] + "-" + date[1] + " " + hour + ":00";
				let to = new Date(
					"20" + date[2],
					parseInt(date[1] - 1),
					date[0],
					parseInt(hour.split(":")[0] - 6),
					hour.split(":")[1]
				);
				let now = new Date();

				let time = now.getTime() < to.getTime() ? to.getTime() : false;
				if (time) {
					return { date, hour, to, time };
				}
				return false;
			},
		},
		methods: {
			...mapActions(["getShipSlots", "resetCashbackPoints", "updateUserInfo"]),

			nextToCheckout() {
				this.$store.commit("setTmpUser", this.$refs.userSearch.selected);
				this.$store.commit("swapUsers");
				this.showScreen = false;
			},
			continueToCheckout() {
				this.showScreen = false;
			},
			goToCart() {
				if (this.permenent) {
					this.$router.push({ path: "/my-account/permenant" });
					this.$store.commit("setPerEdit", false);
				} else {
					this.openCart();
				}
			},
			openCart() {
				setTimeout(() => {
					$(".cart").fadeIn(100, function () {
						$("body").addClass("noscroll");
						$(".cart_in").animate(
							{
								left: 0,
							},
							600
						);
					});
				}, 500);
				this.$router.push({ path: "/" });
			},
			sendAjaxCheckout(data) {
				this.$ajax.post(homeUrl + "?wc-ajax=checkout", data).then((response) => {
					if (response.data.result === "failure") {
						this.errorText = response.data.error ? response.data.error : response.data.messages;
						$(".submit_bt").removeClass("proccessing");
						return false;
					}

          const url = response.data.redirect.url ? response.data.redirect.url : response.data.redirect;

					//this.resetCashbackPoints();
					this.$store.commit("setCoupon", "");
					this.$store.commit("setGiftcard", "");
					//console.log("updateUserInfo");
					this.$store.dispatch("updateUserInfo");

					// If its an actual user -> update local user data
					if (!this.$store.state.orderAs) {
						if (response.data && response.data.user) {
							this.$store.commit("setUserInfo", response.data.user);
						}
					}

					if (url && data.get("billing_payment_card") === "new") {
						store.commit("setPaymentForm", response.data.iframe_form);
						window.location.replace(url);
						return false;
					}

          // analytics event
          // console.log("datalayer before", window.dataLayer);
          // if (typeof window.dataLayer !== "undefined") {
          //   window.dataLayer.push({
          //     event: "purchase",
          //     ecommerce: response.data.event,
          //   });
          //   console.log("datalayer AFTER", window.dataLayer);
          // }

					if (this.$store.state.orderEdit) {
						this.$modal.show("order-update");
						$(".submit_bt").removeClass("proccessing");

            // analytics event
            // console.log("datalayer before", window.dataLayer);
            if (typeof window.dataLayer !== "undefined") {
              window.dataLayer.push({
                event: "purchase",
                ecommerce: response.data.redirect.event ? response.data.redirect.event : response.data.event,
              });
              // console.log("datalayer AFTER", window.dataLayer);
            }
						return false;
					}

					// redirect to thank you page
					if (url && this.$store.state.orderEdit === false) {
						store.commit("setPaymentForm", response.data.iframe_form);
						window.location.replace(url);
					} else {
						router.push({ name: "thank-you" });
					}
				});
			},
			submitCheckOut() {
				var form = document.getElementById("checkout");
				var data = new FormData(form);

				var max_products = this.$store.state.added.length;
				var max_pages = Math.ceil(max_products / 40);
				$(".comax_error").remove();
				//var data = new FormData();
				if (this.stageComplete == 0) {
					this.$refs.checkoutInfo.changeTab("shippment");
					this.$store.commit("changeCheckoutStage", "shippment");
				}
				if (this.stageComplete == 1) {
					this.$refs.checkoutShipment.changeTab("payment");
					this.$store.commit("changeCheckoutStage", "payment");
				}
				if (this.stageComplete == 2) {
					$(".submit_bt").addClass("proccessing");
					data.append("max_pages", max_pages);
					// let res =  this.sendAjaxCheckout(data,0);
					if (this.$store.state.cashback.process.pointsUsed) {
						data.append("cashback_points_used", this.$store.state.cashback.process.pointsUsed);
					}
					this.sendAjaxCheckout(data, 0, max_pages);
					//this.sendAjaxCheckout(data);
				}
			},
			enterPressed() {
				if ($("textarea:focus").length) {
					$("textarea:focus").val($("textarea:focus").val() + "\r\n");
				}
			},
		},
		components: {
			LOGO,
			CART2,
			Info,
			Shipment,
			Payment,
			CARMELLA,
			LoginForm,
			VueSimpleSuggest,
			OrderTimeUp,
			shipmentPer,
		},
	};
</script>

<style scoped>
	.vue-simple-suggest.designed .suggestions {
		top: calc(100% + -1px);
		max-width: 100%;
		width: 100%;
		-webkit-transform: translateX(-0%);
		transform: translateX(0%);
	}
</style>
